module.exports = __webpack_public_path__ + "img/header-weddingRingsRedgold.11a3fcf.webp";